var ComponentsModule = /** @class */ (function () {
    function ComponentsModule() {
    }
    return ComponentsModule;
}());
export { ComponentsModule };
